import { Badge } from "antd"

const WrapperBadge = (props:any)=>{
  const  isImmediate = props.item?.dopingList?.find((item: any) =>
    item.id===9
  );

  return(
    <div>
    {
      isImmediate?<>
      
      <Badge.Ribbon text={"Acil"} color="gold" style={{zIndex:"99999 !important"}} >
        {props.children}
      </Badge.Ribbon>
      </>:<>
      {props.children}
      </>
    }
      
    </div>
  )
}

export default WrapperBadge